import React from 'react';

import { getHeight, getDocumentMaxHeight, getWindowHeight } from '../../../utils/style-properties/height';
import { getOffset } from '../../../utils/style-properties/offset';
import { getPosition } from '../../../utils/style-properties/position';
import { IconUp } from '../../icon/icon';

import './page__up.scss';

import CONSTANTS from './constants.scss';

const SIZE = parseInt(CONSTANTS.pageUpSize, 10);

export default class Up extends React.Component {
    constructor(props) {
        super(props);

        this.state = { hidden: true, style: {} };
        this.onScroll = this.onScroll.bind(this);
    }

    componentDidMount() {
        window.addEventListener('scroll', this.onScroll, { passive: true });

        const footerElement = document.querySelector('.footer');

        this.footerHeight = footerElement ? getHeight(footerElement) : 0;
    }

    shouldComponentUpdate(nextProps, nextState) {
        return (
            (nextState.hidden !== undefined && nextState.hidden !== this.state.hidden) ||
            (nextState.style !== undefined && nextState.style.bottom !== this.state.style.bottom)
        );
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.onScroll);
    }

    onScroll() {
        const windowHeight = getWindowHeight();
        const documentHeight = getDocumentMaxHeight();
        const contentFixedElem = document.querySelector('.footer__top-content_fixed');
        let style = {};

        // таймаут нужен чтобы успел проставиться класс footer__top-content_fixed
        setTimeout(() => {
            if (documentHeight > windowHeight + window.scrollY + this.footerHeight && contentFixedElem?.length) {
                style.bottom += windowHeight - getPosition(contentFixedElem).top;
            }
            if (window.scrollY + windowHeight >= documentHeight - this.footerHeight) {
                style.bottom =
                    -SIZE / 2 + window.scrollY + windowHeight - getOffset(document.querySelector('.footer')).top;
            }
            this.setState({ hidden: window.scrollY < windowHeight * 2, style });
        }, 0);
    }

    render() {
        return (
            <IconUp
                hidden={this.state.hidden}
                mix="page__icon-up"
                onClick={() =>
                    window.scrollTo({
                        top: 0,
                        behavior: 'smooth',
                    })
                }
                style={this.state.style}
            />
        );
    }
}
